import {
  createMuiTheme,
  createGenerateClassName,
} from '@material-ui/core/styles';
import green from '@material-ui/core/colors/green';

import {
  typographyVariantsLarge,
  typographyVariantsSmall,
} from '../typographyVariants';

const palette = {
  primary: {
    light: '#f5f7fa',
    main: '#009a44',
    dark: '#009a44',
  },
  secondary: {
    light: green[300],
    main: green[500],
    dark: '#00672d',
  },
  login: {
    light: '#ffffff',
    main: '#009a44',
    dark: '#333333',
    original: '#00833E',
  },
};

export const masterTheme = {
  palette: {
    primary: {
      light: palette.primary.light,
      main: palette.primary.main,
      dark: palette.primary.dark,
    },
    secondary: {
      light: green[300],
      main: green[500],
      dark: green[700],
    },
  },
  typography: {
    useNextVariants: true,
    fontFamily: ['"Helvetica Neue"', 'Arial', 'sans-serif'].join(','),
    fontSize: 16,
  },
  overrides: {
    MuiTypography: {
      colorTextSecondary: {
        color: 'white',
      },
      button: {
        color: 'white',
        cursor: 'pointer',
      },
    },
    MuiInputLabel: {
      formControl: {
        fontWeight: '600',
        fontSize: '1rem',
        color: '#000',
        marginBottom: '-1.1rem',
        position: 'relative',
      },
      formControlFocused: {
        textTransform: 'uppercase',
      },
    },
    MuiButton: {
      containedPrimary: {
        color: palette.login.light,
        width: '100%',
        '&:disabled': {
          color: 'grey',
        },
      },
      outlinedSecondary: {
        color: palette.login.light,
        borderColor: palette.login.light,
        width: '100%',
        '&:disabled': {
          color: 'grey',
        },
        '&:hover': {
          backgroundColor: palette.login.light,
          color: 'black',
        },
      },
      textSecondary: {
        color: palette.login.light,
        borderColor: palette.login.light,
        '&:hover': {
          background: 'none',
        },
      },
    },
  },
};

// IMPORTANT: the width parameter is only available for components which uses the withWidth HOC
// Currently, we only have the LoginPage component uses the withWidth HOC.
export const muiThemeMaster = width => {
  const exportMasterTheme = masterTheme;
  if (width === 'xs') {
    exportMasterTheme.overrides.MuiTypography = {
      ...masterTheme.overrides.MuiTypography,
      ...typographyVariantsSmall,
    };
  } else {
    exportMasterTheme.overrides.MuiTypography = {
      ...masterTheme.overrides.MuiTypography,
      ...typographyVariantsLarge,
    };
  }
  return exportMasterTheme;
};

export const muiTheme = createMuiTheme(muiThemeMaster());

export const generateClassName = createGenerateClassName();
